import {attachTooltips} from "../pages/survey/questions/attach-tooltips";

$(function () {
    $('[data-toggle="tooltip"]').not('.help-tooltip').tooltip();

    attachTooltips($('body'));

    //add text from input to tooltip 
    $('.tooltip-text-from-input').on('change', function() {
        let inputValue = $(this).val();
        $(this).attr('data-original-title', inputValue);
    })
})

